import React from 'react';


const DescriptionSlide = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'DescriptionSlide',


  /**
   * Timeout to show emojis
   */
  showTimeout: 0,


  /**
   * Expected propTypes
   * @prop {Boolean} active - If this is the current active slide
   * @prop {Object} cssTransforms3d - Whether the browser
   * supports css 3d transforms
   * @prop {Object} data - A data object
   * @prop {Number} height - The height for the slide's style
   * @prop {Boolean} next - If this is the next from the active slide
   * @prop {Boolean} prev - If this is the previous from the active slide
   * @prop {Boolean} touch - If browser supports touch events
   * @prop {Number} yPosition - The top position for the slide's style
   */
  propTypes: {
    active: React.PropTypes.bool,
    cssTransforms3d: React.PropTypes.bool,
    data: React.PropTypes.object.isRequired,
    height: React.PropTypes.number,
    next: React.PropTypes.bool,
    prev: React.PropTypes.bool,
    touch: React.PropTypes.bool,
    yPosition: React.PropTypes.number,
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    // const clickHandler = this.p
    const data = this.props.data;
    const prevClass = this.props.prev ? ' prev' : '';
    const activeClass = this.props.active ? ' active' : '';
    const nextClass = this.props.next ? ' next' : '';
    const className = 'component-description-slide slide ' +
      prevClass +
      activeClass +
      nextClass;
    const style = {
      height: this.props.height,
      top: this.props.yPosition,
    };

    return (
      <div style={style} className={className}>
        <div className='text-wrapper'>
          <div className='text'>{data.text}</div>
        </div>
      </div>
    );
  },
});

export default DescriptionSlide;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/DescriptionSlide.jsx
 **/